import { Component } from 'react';
import AppContext from '../../controllers/AppContext';
import logService from '../wss/logService3';
import { publish } from '../utils/pubsub';
import { events } from '../wss/SystemEvents';

/**
 * Base class for all React class components.
 * Mirrors CoreBase — provides token access, error handling and logging.
 */
export default class CoreComponent extends Component {
    _name = 'CoreComponent';

    setCurrentTab = (tab) => {
        AppContext.setCurrentTab(tab);
    };

    /**
     * Returns the current JWT token from AppContext.
     * @returns {string|null}
     */
    getToken = () => AppContext.getToken();

    /**
     * Returns the current user ID from AppContext.
     * @returns {string|null}
     */
    getUid = () => AppContext.getUid();

    /**
     * Returns the current tab ID from AppContext.
     * @returns {string|null}
     */
    getTabId = () => AppContext.getTabId();

    /**
     * Publishes a message event — consumed by toast/notification handler.
     * @param {string} message
     * @param {string} type - 'success' | 'error' | 'info'
     */
    onMessage = (message, type = 'info') => {
        publish(events.onMessage, { source: this._name, message, type });
    };

    /**
     * Publishes an error event via pubsub — caught by ErrorEngine, no direct coupling.
     * @param {string} message
     * @param {*} data
     */
    onError = (message, data = null) => {
        publish(events.onError, { source: this._name, message, data });
    };

    /**
     * Logs an error via logService and publishes to ErrorEngine via onError.
     * @param {string} method
     * @param {string} message
     */
    logError = (method, message) => {
        logService.logError(`${this._name}.${method}: ${message}`);
        this.onError(message);
    };

    /**
     * Logs a debug message via logService.
     * @param {string} method
     * @param {string} message
     */
    logDebug = (method, message) => {
        logService.log(`${this._name}.${method}: ${message}`);
    };
}
